import React from "react";
import { Check, X } from "lucide-react";

const styles = {
  correct: "bg-emerald-600 border-emerald-400 text-white shadow-lg shadow-emerald-900/40",
  incorrect: "bg-rose-700 border-rose-500 text-white shadow-lg shadow-rose-950/40",
  unused: "bg-zinc-800/80 border-zinc-700 text-zinc-600",
};

export const GuessTiles = ({ tiles, size = "md" }) => {
  const dim =
    size === "lg" ? "w-11 h-11 sm:w-14 sm:h-14" : size === "sm" ? "w-6 h-6" : "w-9 h-9 sm:w-10 sm:h-10";
  return (
    <div className="flex items-center gap-2" data-testid="guess-tiles">
      {tiles.map((t, i) => (
        <div
          key={i}
          data-testid={`tile-guess-${i}`}
          data-state={t}
          className={`${dim} rounded-lg border-2 flex items-center justify-center ac-flip ${styles[t]}`}
          style={{ animationDelay: `${i * 60}ms` }}
        >
          {t === "correct" && <Check className="w-1/2 h-1/2" strokeWidth={3} />}
          {t === "incorrect" && <X className="w-1/2 h-1/2" strokeWidth={3} />}
        </div>
      ))}
    </div>
  );
};

export const tilesToEmoji = (tiles) =>
  tiles
    .map((t) => (t === "correct" ? "🟩" : t === "incorrect" ? "🟥" : "⬜"))
    .join("");
